<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    <div class="header-content">
      <h3 class="modal-title">{{ modalTitle }}</h3>
      <div class="header-icons">
        <i class="fa minimize-icon"
           [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           (click)="minimise = !minimise"></i>
        <i class="fa fa-times close-icon" (click)="cancel()"></i>
      </div>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" [class.collapsed]="minimise">

    @if (dataLoading) {
<div class="loading-container">
      <i class="fa fa-spinner fa-spin loading-icon"></i>
      <div class="loading-text">Loading Schedule F data...</div>
    </div>
}

    @if (!dataLoading) {
<div class="schedule-f-container">
      <div class="instructions">
        <h4>
          <i class="fa fa-info-circle"></i>
          All Amounts are in US Dollars translated in accordance with U.S. GAAP.
          Enter the Adjustment Amount in Schedule F Balance Sheet, Click 'Save' to save changes made on this screen.
        </h4>
      </div>

      <!-- Assets Table -->
      <table class="table table-bordered schedule-table">
        <thead>
          <tr>
            <th rowspan="2" class="text-center" style="width: 6%;">5471 Line</th>
            <th rowspan="2" class="text-center">Assets</th>
            <th rowspan="2" class="text-center">Prior year as Filed per FIR<br>(a)</th>
            <th rowspan="2" class="text-center">Current year Beginning balance as per FIR<br>(b)</th>
            <th rowspan="2" class="text-center">Adjustment to Current year beginning balance<br>(c)</th>
            <th rowspan="2" class="text-center">Beginning of annual accounting period<br>(d = b + c)</th>
            <th rowspan="2" class="text-center">End of annual accounting period</th>
          </tr>
        </thead>
        <tbody>
          @for (line of getLinesByType('Assets'); track trackByLineNo($index, line)) {
<tr [ngStyle]="line.backgroudColor || null">
            <td class="text-center line-number">{{ line.line_no }}</td>
            <td class="line-description">{{ line.line_Description }}</td>
            @if (line.col_a?.is_Display) {
<td class="text-right column-cell">
              {{ line.startDelimiter }}{{ (line.col_a?.VALUE | number) || 0 }}{{ line.endDelimiter }}
            </td>
}
            @if (!line.col_a?.is_Display) {
<td class="text-right column-cell"></td>
}
            @if (line.col_b?.is_Display) {
<td class="text-right column-cell">
              {{ line.startDelimiter }}{{ (line.col_b?.VALUE | number) || 0 }}{{ line.endDelimiter }}
            </td>
}
            @if (!line.col_b?.is_Display) {
<td class="text-right column-cell"></td>
}
            @if (line.col_c?.is_Display) {
<td class="text-right column-cell">
              @if (line.col_c?.is_editable) {
<input
                     type="text"
                     [(ngModel)]="line.col_c!.VALUE"
                     class="text-right form-control input-sm numText"
                     placeholder="0"
                     (ngModelChange)="onColCChange(line.line_no)">
}
              @if (!line.col_c?.is_editable) {
<span>
                {{ line.startDelimiter }}{{ (line.col_c?.VALUE | number) || 0 }}{{ line.endDelimiter }}
              </span>
}
            </td>
}
            @if (!line.col_c?.is_Display) {
<td class="text-right column-cell"></td>
}
            @if (line.col_d?.is_Display) {
<td class="text-right column-cell">
              {{ line.startDelimiter }}{{ (line.col_d?.VALUE | number) || 0 }}{{ line.endDelimiter }}
            </td>
}
            @if (!line.col_d?.is_Display) {
<td class="text-right column-cell"></td>
}
            @if (line.col_e?.is_Display) {
<td class="text-right column-cell">
              {{ line.startDelimiter }}{{ (line.col_e?.VALUE | number) || 0 }}{{ line.endDelimiter }}
            </td>
}
            @if (!line.col_e?.is_Display) {
<td class="text-right column-cell"></td>
}
          </tr>
}
        </tbody>
      </table>

      <!-- Liabilities Table -->
      <table class="table table-bordered schedule-table">
        <thead>
          <tr>
            <th rowspan="2" class="text-center" style="width: 6%;">5471 Line</th>
            <th rowspan="2" class="text-center">Liabilities and Stockholder's Equity</th>
            <th rowspan="2" class="text-center">Prior year as Filed per FIR<br>(a)</th>
            <th rowspan="2" class="text-center">Current year Beginning balance as per FIR<br>(b)</th>
            <th rowspan="2" class="text-center">Adjustment to Current year beginning balance<br>(c)</th>
            <th rowspan="2" class="text-center">Beginning of annual accounting period<br>(d = b + c)</th>
            <th rowspan="2" class="text-center">End of annual accounting period</th>
          </tr>
        </thead>
        <tbody>
          @for (line of getLinesByType('Liabilities'); track trackByLineNo($index, line)) {
<tr [ngStyle]="line.backgroudColor || null">
            <td class="text-center line-number">{{ line.line_no }}</td>
            <td class="line-description">{{ line.line_Description }}</td>
            <td class="text-right column-cell" [style.visibility]="line.col_a?.is_Display ? 'visible' : 'hidden'">
              {{ line.startDelimiter }}{{ (line.col_a?.VALUE | number) || 0 }}{{ line.endDelimiter }}
            </td>
            <td class="text-right column-cell" [style.visibility]="line.col_b?.is_Display ? 'visible' : 'hidden'">
              {{ line.startDelimiter }}{{ (line.col_b?.VALUE | number) || 0 }}{{ line.endDelimiter }}
            </td>
            <td class="text-right column-cell" [style.visibility]="line.col_c?.is_Display ? 'visible' : 'hidden'">
              @if (line.col_c?.is_editable) {
<input
                     type="text"
                     [(ngModel)]="line.col_c!.VALUE"
                     class="text-right form-control input-sm numText"
                     placeholder="0"
                     (ngModelChange)="onColCChange(line.line_no)">
}
              @if (!line.col_c?.is_editable) {
<span>
                <b>{{ line.startDelimiter }}</b>{{ (line.col_c?.VALUE | number) || 0 }}<b>{{ line.endDelimiter }}</b>
              </span>
}
            </td>
            <td class="text-right column-cell" [style.visibility]="line.col_d?.is_Display ? 'visible' : 'hidden'">
              {{ line.startDelimiter }}{{ (line.col_d?.VALUE | number) || 0 }}{{ line.endDelimiter }}
            </td>
            <td class="text-right column-cell" [style.visibility]="line.col_e?.is_Display ? 'visible' : 'hidden'">
              {{ line.startDelimiter }}{{ (line.col_e?.VALUE | number) || 0 }}{{ line.endDelimiter }}
            </td>
          </tr>
}
        </tbody>
      </table>

      <!-- Notes -->
      @if (irs5471ScheduleFNotes?.VALUE) {
<div class="row form-group notes-section">
        <span class="col-md-10">
          <label>Notes:</label>
          <textarea
            name="notes"
            placeholder="Add message"
            class="form-control input-sm"
            [(ngModel)]="irs5471ScheduleFNotes!.VALUE!.VALUE"
            (ngModelChange)="onNotesChange()"
            rows="5"></textarea>
        </span>
      </div>
}

      @if (userMessage) {
<div class="alert alert-warning">
        {{ userMessage }}
      </div>
}
    </div>
}
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer">
    <button class="btn btn-info btn-sm save-button" type="button" (click)="saveScheduleFDetails()" [disabled]="crudLoading">
      @if (crudLoading) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
} Save
    </button>
    <button class="btn btn-danger-outline btn-sm reset-button" type="button" (click)="reset()">Reset</button>
    <button class="btn btn-warning btn-sm cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
